<template>
  <div v-if="loaded">
    <sc-panel-navigator @update="updateTable" @done="++clock"    :drawerWidth="270">
      <el-card>
        <div
            slot="header"
            class="clearfix">
          <span style="float:left">Partners</span>

          <el-button
              style="float:right"
              size="large"
              type="success"
              @click="loadTourCo('new')">
            <fa
                icon="plus"
                fixed-width></fa>
            <fa
                icon="cubes"
                fixed-width
                size="lg"></fa>
          </el-button>
        </div>
        <el-row>
          <el-col :md="16">
            <el-input v-model="searchall" placeholder="..company name"></el-input>
          </el-col>
          <el-col :md="8">
            <el-input placeholder="year" clearable v-model="wYear"></el-input>
          </el-col>
        </el-row>
        <div>
          <s-table
              :key="clock"
              :colDefinitions="colCoDefinitions"
              modx-processor="tourcompany/getlist"
              :r-query="{q:searchall,_all:true,year:wYear}"
              @cell-clicked="loadTourCo"
              :cellClassFactory="scp=>!!scp.row.unpublished_at?'disabled_row':null"
              ref="tourCoList"></s-table>
        </div>
      </el-card>
    </sc-panel-navigator>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";
import ScPanelNavigator from "../../Layout/PanelNavigator";

export default {
  components: {ScPanelNavigator},
  mixins: [printHtml],
  data() {
    return {
      clock: 0,
      printData: null,
      printReady: false,
      loaded: false,

      searchall: null,

      cols: {},
      dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    updateTable(msg) {
      _log_("hell.UPDATE..", msg);
      this.$refs.tourCoList.updateOrAppendRow(msg);
    },
    loadTourCo(selector) {
      _log_("hell...", selector);
      const id = selector.row ? selector.row.id : selector;
      this.routeGo({
        name: "tourco",
        params: {tourcoid: id},
      });
    },
  },
  async mounted() {
    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    wYear: {
      get() {
        return this.$route.query.wYear ? this.$route.query.wYear : null
      },
      set(v) {
        this.routeGo({query: {wYear: v}})
      }
    },
    colCoDefinitions() {
      var rw = "580px",
          vm = this;
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        {prop: "coname", cwidth: "80%", label: "Name"},
        {prop: "year", width: "80px", label: "Year"},
        // {prop: "deleted_at",label: 'deleted_at'}
        // { prop: "year", width: "", label: "Date", formatterType: "unxToDate" }
      ];
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style>
